<template>
  <div class="privacy-policy">
      <h1>Privacy Policy</h1>
      <p class="last-updated"><strong>Last updated:</strong> October 6, 2026</p>

      <p>
        <b>Lightholm</b> is a single-player game. This policy explains what the
        game does with information about you.
      </p>

      <hr />

      <h2>What the Game Collects</h2>
      <p>
        Lightholm has no accounts, no ads and no leaderboards on Android, and it
        does not ask for any permissions to read your contacts, location, photos,
        microphone or camera.
      </p>
      <p>
        The game saves your progress and settings (boards cleared, the
        constellation you have lit, sound levels, language) on your own device.
        That data stays on the device. It is not sent to us.
      </p>
      <p>The one exception is buying the full game, below.</p>

      <hr />

      <h2>Purchases</h2>
      <p>
        The first five boards are free. Unlocking the full game is a one-time
        purchase made through <strong>Google Play</strong>. Google handles the
        payment and your payment details; we never see them. The game receives a
        confirmation from Google Play that the purchase belongs to your Google
        account, and remembers on your device that the full game is unlocked.
        Google's own privacy policy covers what Google Play does with your
        purchase:
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a>
      </p>
      <p>
        The game talks to Google Play through <strong>Unity In-App Purchasing</strong>,
        a library made by Unity Technologies. When you start, complete or cancel a
        purchase, that library sends Unity a record of it: the product, its price
        and currency, the order ID, your device model and Android version, the
        game's version, your approximate location (country or region), and random
        identifiers for your device and session. Unity uses this to run and
        measure its purchase service. Unity's privacy policy covers that data:
        <a href="https://unity.com/legal/game-player-and-app-user-privacy-policy" target="_blank" rel="noopener">https://unity.com/legal/game-player-and-app-user-privacy-policy</a>
      </p>
      <p>
        Unity does not get your payment details, your name or your Google account
        password.
      </p>

      <hr />

      <h2>Backups</h2>
      <p>
        If Android's own backup is turned on for your device, Android may include
        the game's saved progress in your Google account backup, so it comes back
        on a new phone. That is a feature of Android, controlled in your device
        settings.
      </p>

      <hr />

      <h2>Children</h2>
      <p>
        Lightholm is not directed at children under 13 and does not knowingly
        collect personal information from anyone.
      </p>

      <hr />

      <h2>Changes</h2>
      <p>
        If this policy changes, the new version will be posted at this address
        with a new date.
      </p>

      <hr />

      <h2>Contact</h2>
      <p>
        Questions about this policy:
        <a href="mailto:chayanutp39@gmail.com">chayanutp39@gmail.com</a>
      </p>
    </div>
</template>

<script>
export default {
  name: 'LightholmPrivacyPolicy'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.privacy-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    line-height: 1.6;
    text-align: left;

    color: white;
    background-color: #252525;
    font-family: sans-serif;
  }
h1 {
  text-align: center;
}
.last-updated {
  text-align: center;
  color: #bbb;
}
a {
  color: #42b983;
  word-break: break-word;
}
</style>
